// ==================================================================================================
//
// Api Functions
//
// ==================================================================================================

export const getCheckins = (memberId, onSuccess, onError) => {
  $.ajax({
    url: `/api/internal/members/${memberId}/checkins`,
    dataType: 'json',
    success: onSuccess,
    error: onError
  })
}

export const updateMember = ($form) => {
  $.ajax({
    url: $form.attr('action'),
    type: 'post',
    data: $form.serialize(),
    dataType: 'json'
  })
}

export const getClassHistory = ({ memberId, status, startDate, endDate, onSuccess, onError }) => {
  const path = `/api/internal/members/${ memberId }/class_history?start_date=${ startDate }&end_date=${ endDate }`
  const url = status !== 'all' ? `${ path }&status=${ status }` : path

  $.ajax({
    url,
    type: 'get',
    dataType: 'text',
    success: onSuccess,
    error: onError
  })
}

export const getPurchaseHistory = ({ memberId, startDate, endDate, onSuccess, onError }) => {
  const url = `/api/internal/members/${ memberId }/billing_history?start_date=${ startDate }&end_date=${ endDate }`

  $.ajax({
    url,
    type: 'get',
    dataType: 'text',
    success: onSuccess,
    error: onError
  })
}

export const agreeOnTerms = (memberId, onSuccess, onError) => {
  $.ajax({
    url: `/api/internal/members/${memberId}/opt_in_to_fees`,
    type: 'post',
    dataType: 'text',
    success: onSuccess,
    error: onError
  })
}